module.exports = __webpack_public_path__ + "static/media/Remove-Lid.5a61d700.svg";